import { OrgRole, UserRole } from '@core/models/users';

export const rolesMap = new Map<UserRole | OrgRole, { en: string }>([
  [UserRole.USER, { en: 'Teammate' }],
  [UserRole.ADMIN, { en: 'Root Admin' }],
  [OrgRole.USER, { en: 'Teammate' }],
  [OrgRole.OWNER, { en: 'Organization Manager' }],
  [UserRole.LOCKED_USER, { en: 'Invitation Pending' }],
]);
